import { ROW_HIGHLIGHTED_COLOR } from "src/config/constants/genericConstants";

const formatCommissionCalculationData = (data: any) => {
  if (!data) {
    return {
      caCommissionCalculationData: null,
      commissionCalculationData: null
    };
  }
  const [calculationData] = data;
  const caCommissionCalculationData = calculationData?.items?.map(
    (item: any) => ({
      key: item.key,
      title: item.text,
      level: item.level,
      allDepartmentCost: item["allDepartment-Cost"],
      allDepartmentRetail: item["allDepartment-Retail"],
      allDepartmentMargin: item["allDepartment-Margin"],
      nonBeerOrWineCost: item["nonBeerOrWine-Cost"],
      nonBeerOrWineRetail: item["nonBeerOrWine-Retail"],
      nonBeerOrWineMargin: item["nonBeerOrWine-Margin"],
      beerOrWineCost: item["BeerOrWine-Cost"],
      beerOrWineRetail: item["BeerOrWine-Retail"],
      beerOrWineMargin: item["BeerOrWine-Margin"],
      bold: item?.style?.bold,
      highlightColor: item?.style?.highlight && ROW_HIGHLIGHTED_COLOR,
      underline: item?.style?.underline,
      grossMarginCommissionCalculationReport: true
    })
  );

  const commissionCalculationData = calculationData?.items?.map(
    (item: any) => ({
      key: item.key,
      title: item.text,
      level: item.level,
      allDepartmentCost: item["allDepartment-Cost"],
      allDepartmentRetail: item["allDepartment-Retail"],
      allDepartmentMargin: item["allDepartment-Margin"],
      bold: item?.style?.bold,
      highlightColor: item?.style?.highlight && ROW_HIGHLIGHTED_COLOR,
      underline: item?.style?.underline,
      grossMarginCommissionCalculationReport: true
    })
  );

  return { caCommissionCalculationData, commissionCalculationData };
};

export default formatCommissionCalculationData;
